import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { MessageService } from 'primeng/api';
import { FormBuilder, Validators } from '@angular/forms';
import { CustomValidator } from 'src/app/shared/custom-validator';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';
import { SelfSchedulingConfigService } from 'src/app/admin/servicies/self-scheduling-config-service';
import { SelfSchedulingConfigModel, SelfSchedulingGeneralSetupModel, SelfSchedulingWrapper } from 'src/app/shared/models/response/settings/self-scheduling-config-model';
import { DialogService } from 'primeng/dynamicdialog';
import { PreviewTemplateComponent } from './preview-template/preview-template.component';
import { NotificationResponseModel } from 'src/app/shared/models/response/notificationinapp-response-model';
import { SidebarService } from 'src/app/admin/servicies/sidebar.service';
import { CreateConfigurationComponent } from './create-configuration/create-configuration.component';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { PreviewConfigurationComponent } from './preview-configuration/preview-configuration.component';
import { NotificationService } from 'src/app/admin/servicies/notification.service';
import { ResultOfT } from 'src/app/shared/models/response/result';
import { DropdownModel } from 'src/app/shared/models/response/settings/drop-down-model';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';

@Component({
  selector: 'app-self-scheduling-config',
  templateUrl: './self-scheduling-config.component.html',
  styleUrls: ['./self-scheduling-config.component.sass'],
  standalone: false
})
export class SelfSchedulingConfigComponent extends BaseComponent implements OnInit {
  model = {} as SelfSchedulingWrapper;
  configs: SelfSchedulingConfigModel[] = [];
  classificationDurationOptions = [
    { title: '15 Minutes', value: 15 },
    { title: '30 Minutes', value: 30 },
    { title: '45 Minutes', value: 45 },
    { title: '60 Minutes', value: 60 },
    { title: '75 Minutes', value: 75 },
    { title: '90 Minutes', value: 90 },
    { title: '105 Minutes', value: 105 },
    { title: '120 Minutes', value: 120 }];
  expiryPeriodOptions = [
    { title: 'Minutes', value: 'Minutes' },
    { title: 'Hours', value: 'Hours' },
    { title: 'Days', value: 'Days' }];
  showDailog = false;
  optionalOnlineLabel: string;
  optionalFacilityLabel: string;
  defaultTemplate: string;
  defaultTemplateId: number;
  showMaxConfigLimitPopup = false;
  templateOptions: DropdownModel[] = [];
  isGroupAppointmentFeatureSubscribed: boolean = false;
  constructor(private webStorageService: WebStorageService,
    private formBuilder: FormBuilder,
    private configService: SelfSchedulingConfigService,
    private dialogueService: DialogService,
    private sidebarService: SidebarService,
    messageService: MessageService,
    private notificationService: NotificationService,
    private authenticationService: AuthenticationService
  ) {
    super(messageService);
    

    const clientConfig = this.webStorageService.getClientConfig();
    if (clientConfig) {
      this.isGroupAppointmentFeatureSubscribed = clientConfig.isGroupAppointment
        ? clientConfig.isGroupAppointment
        : false;
    }
  }

  ngOnInit() {
    this.buildForm();
    this.loadData();
    this.addDynamicValidation();
    this.getInvitationTemplates(0, 'AppointmentInvitation', 'SMS');
    this.sidebarService.isSidebarVisible().subscribe(x => {
      if (!x) {
        this.loadData();
        this.loadTemplates();
      }
    })
  }

  private buildForm() {
    this.form = this.formBuilder.group({

      general: this.formBuilder.group({
        leadTime: ['', [Validators.required, CustomValidator.whitespace, CustomValidator.onlyNumbers, CustomValidator.positiveDecimalNumber]],
        numOfDays: ['', [Validators.required, CustomValidator.whitespace, CustomValidator.onlyNumbers, CustomValidator.positiveDecimalNumber, CustomValidator.range]],
        unreconciled: ['', [Validators.required, CustomValidator.whitespace, CustomValidator.onlyNumbers, CustomValidator.positiveDecimalNumber]],
        displayNote: ['', [Validators.required]],
        displayDueAmount: ['', [Validators.required]],
        slotDuration: ['', [Validators.required]],
        slotBasedOnClassification: ['', [Validators.required]],
        expiryPeriodAppointmentLink: ['', [Validators.required]],
        expiryPeriod: ['', [Validators.required]],
        enableGroupSession: [false, [Validators.required]],
        expiryPeriodDuration: ['', [Validators.required, CustomValidator.whitespace, CustomValidator.onlyNumbers]],
      }),

      selfScheduleOption: this.formBuilder.group({
        isEnabled: [false, [Validators.required]],
        templateId: [false, [Validators.required]]
      }),

      custom: this.formBuilder.group({
        isCustomConfig: [false, [Validators.required]]
      }),

      selfScheduling: this.formBuilder.group({
        isFreshRemoteTypeAppointment: [null],
        isFreshFacilityTypeAppointment: [null],
        isCancellationAllowed: [null],
        isLimitNoOfCancelAppointments: [null],
        maxCancelAllowed: [null],
        isRescheduleAllowed: [null],
        isLimitNoOfRescheduleAppointments: [null],
        maxRescheduleAllowed: [null],
        isRescheduleRemoteAppointmentType: [null],
        isRescheduleFacilityAppointmentType: [null]
      })
    });

  }

  addDynamicValidation() {
    this.form.get('selfScheduling.isLimitNoOfCancelAppointments')?.valueChanges.subscribe(value => {
      if (value) {
        this.form.get('selfScheduling.maxCancelAllowed')?.setValidators([Validators.required]);
      } else {
        this.form.get('selfScheduling.maxCancelAllowed')?.clearValidators();
      }
      this.form.get('selfScheduling.maxCancelAllowed')?.updateValueAndValidity();
    });

    this.form.get('selfScheduling.isLimitNoOfRescheduleAppointments')?.valueChanges.subscribe(value => {
      if (value) {
        this.form.get('selfScheduling.maxRescheduleAllowed')?.setValidators([Validators.required]);
      } else {
        this.form.get('selfScheduling.maxRescheduleAllowed')?.clearValidators();
      }
      this.form.get('selfScheduling.maxRescheduleAllowed')?.updateValueAndValidity();
    });

    // Add validation for expiry period
    this.form.get('general.expiryPeriodAppointmentLink')?.valueChanges.subscribe(value => {
      const expiryPeriodControl = this.form.get('general.expiryPeriod');
      const expiryValueControl = this.form.get('general.expiryPeriodDuration');
      if (value === true) { // When "Expire after specified time" is selected
        expiryPeriodControl?.setValidators([Validators.required]);
        this.setExpiryValueValidators();
      } else { // When "Never Expire" is selected
        expiryPeriodControl?.clearValidators();
        expiryValueControl?.clearValidators();
      }

      expiryPeriodControl?.updateValueAndValidity();
      expiryValueControl?.updateValueAndValidity();
    });

    // Add validation for expiry period duration change
    this.form.get('general.expiryPeriod')?.valueChanges.subscribe(() => {
      this.setExpiryValueValidators();
    });

  }



  private setExpiryValueValidators() {
    const expiryValueControl = this.form.get('general.expiryPeriodDuration');
    const expiryPeriodValue = this.form.get('general.expiryPeriod')?.value;
    const isExpiryEnabled = this.form.get('general.expiryPeriodAppointmentLink')?.value;

    if (!isExpiryEnabled) {
      return;
    }

    let validators = [Validators.required, CustomValidator.whitespace, CustomValidator.onlyNumbers];

    switch (expiryPeriodValue) {
      case 'Minutes':
        validators.push(Validators.min(1), Validators.max(59));
        break;
      case 'Hours':
        validators.push(Validators.min(1), Validators.max(23));
        break;
      case 'Days':
        validators.push(Validators.min(1), Validators.max(365));
        break;
      default:
        validators.push(CustomValidator.positiveDecimalNumber);
        break;
    }

    expiryValueControl?.setValidators(validators);
    expiryValueControl?.updateValueAndValidity();
  }

  loadData() {
    this.loading = true;
    this.configService.getAll().subscribe((res) => {
      this.loading = false;
      this.fillData(res?.responseModel);
      this.model = res.responseModel;
    }, (error) => {
      this.loading = false;
      this.showErrorMessage(error.message);
    });
  }


  loadTemplates() {
    this.loading = true;
    this.configService.GetAllSubTemplate().subscribe((res) => {
      this.loading = false;
      this.templateOptions = res.responseModel.map(item => ({
        value: item.id,
        name: item.appNotificationEventName
      }));
    });
  }

  getTemplateName(templateId: number) {
    const template = this.templateOptions.find(x => x.value === templateId);
    return template ? template.name : null;
  }

  fillData(dataWrapper: SelfSchedulingWrapper) {
    let { setup, configs } = dataWrapper;
    let config = configs.find(x => x.isDefault === true);
    this.configs = configs.filter(x => x.isDefault === false);
    this.form.patchValue({
      general: { ...setup },
      selfScheduling: { ...config?.jsonValue },
      selfScheduleOption: { isEnabled: setup?.isEnabled ?? null },
      custom: { isCustomConfig: setup?.isCustomConfig ?? null }
    });
    this.optionalFacilityLabel = setup.labels.find(x => x.key === 'facility-visit')?.value;
    this.optionalOnlineLabel = setup.labels.find(x => x.key === 'remote-setup')?.value;
  }

  onLabelChange(value) {
    if (value.key === 'facility-visit') {
      this.optionalFacilityLabel = value?.value;
    }
    if (value.key === 'remote-setup') {
      this.optionalOnlineLabel = value?.value;
    }
  }

  exceedCustomeconfigLimit() {
    return this.model.configs.filter(x => !x.isDefault).length >= 5;
  }

  save() {
    if (this.form.invalid) {
      this.markFormAsTouched();
      return;
    }

    this.loading = true;
    let userId = this.webStorageService.getCurrentUserToken()?.userId;
    const labels = this.model.setup.labels.map(({ isEditMode, ...rest }) => rest);
    let selfSchedulingGeneralSetupObj: SelfSchedulingGeneralSetupModel = { labels, ...this.form.value.general, ...this.form.value.selfScheduleOption, ...this.form.value.custom };
    let selfSchedulingConfigObj: SelfSchedulingConfigModel = { jsonValue: { ...this.form.value.selfScheduling, templateId: this.defaultTemplateId }, isDefault: true };
    const model = { setup: selfSchedulingGeneralSetupObj, configs: [selfSchedulingConfigObj], modifiedByUserInfoId: userId } as SelfSchedulingWrapper;
    this.configService.save(model).subscribe(res => {
      this.loading = false;
      this.showSuccessMessage('Custom Configuration has been saved successfully.');
      this.loadData();
    },
      (error) => {
        this.loading = false;
        this.showErrorMessage(error.message);
      }
    );
  }

  EmailPreviewClick() {
    this.dialogueService
      .open(PreviewTemplateComponent, {
        showHeader: true,
        closable: true,
        data: { roleId: 0, type: 'AppointmentInvitation', templateType: 'Email' }
      })
  }

  SMSPreviewClick() {
    this.dialogueService
      .open(PreviewTemplateComponent, {
        showHeader: true,
        closable: true,
        data: { roleId: 0, type: 'AppointmentInvitation', templateType: 'SMS' }
      });
  }
  private getInvitationTemplates(roleId: number, type: string, templateType: string) {
    this.loading = true;
    this.notificationService.GetInvitationTempates(roleId, type)
      .subscribe((result: ResultOfT<NotificationResponseModel[]>) => {
        this.processResult<any>(result, () => {
          this.defaultTemplate = result.responseModel[0]?.appNotificationTemplateName;
          this.defaultTemplateId = result.responseModel[0].appNotificationId;
        });
      }, (httpResponseError) => {
        this.showErrorMessage(httpResponseError.message);
      });
  }

  openSidebar(config: SelfSchedulingConfigModel | null) {
    if (config == null && this.exceedCustomeconfigLimit()) {
      this.showMaxConfigLimitPopup = true;
      return;
    }
    let currentConfigCount = config?.id > 0 ? this.configs?.length - 1 : this.configs?.length || 0;
    let userId = this.webStorageService.getCurrentUserToken()?.userId;
    const labels = this.model.setup.labels.map(({ isEditMode, ...rest }) => rest);
    let selfSchedulingGeneralSetupObj: SelfSchedulingGeneralSetupModel =
      { labels, ...this.form.value.general, ...this.form.value.selfScheduleOption, ...this.form.value.custom };
    this.sidebarService.open(CreateConfigurationComponent, {
      configs: [config], setup: selfSchedulingGeneralSetupObj, modifiedByUserInfoId: userId, totalCustomeConfig: currentConfigCount,
      width: '800px',
    });
  }

  onMaxLimitCancel() {
    this.showMaxConfigLimitPopup = false;
  }

  delete(id: number) {
    this.dialogueService
      .open(ConfirmDialogComponent, {
        data: {
          message: `Are you sure you want to delete ?`
        },
        header: 'Confirmation'
      })
      .onClose.subscribe((response: boolean) => {
        if (!response)
          return;
        this.configService.deleteById(id).subscribe((res: any) => {
          this.showSuccessMessage('Configuration has been deleted successfully.');
          this.loadData();
        });
      });
  }

  clone(config: SelfSchedulingConfigModel) {
    if (this.exceedCustomeconfigLimit()) {
      this.showMaxConfigLimitPopup = true;
      return;
    }
    let userId = this.webStorageService.getCurrentUserToken()?.userId;
    const labels = this.model.setup.labels.map(({ isEditMode, ...rest }) => rest);
    let selfSchedulingGeneralSetupObj: SelfSchedulingGeneralSetupModel = { labels, ...this.form.value.general, ...this.form.value.selfScheduleOption, ...this.form.value.custom };
    this.sidebarService.open(CreateConfigurationComponent, { configs: [{ ...config, id: 0 }], setup: selfSchedulingGeneralSetupObj, modifiedByUserInfoId: userId, totalCustomeConfig: this.configs.length });
  }

  previewConfig(config: SelfSchedulingConfigModel) {
    this.dialogueService
      .open(PreviewConfigurationComponent, {
        showHeader: true,
        closable: true,
        data: config
      });
  }

}
